"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheArtOfTheExperience() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY * 0.08);
    };
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      handleScroll();
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return <section data-section-id="105521" id="culinary-experiences" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-secondary/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex flex-col lg:flex-row items-center">
          
          {}
          <div ref={textRef} className={`w-full lg:w-2/3 lg:pr-24 relative z-0 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight mb-10 text-foreground">
              A Fusion of Heart & <span className="text-primary italic">Heritage</span>
            </h2>
            
            <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-light leading-relaxed">
              <p className="first-letter:text-7xl first-letter:font-serif first-letter:text-secondary first-letter:float-left first-letter:mr-4 first-letter:mt-[-0.15em] first-letter:leading-none">
                At Ubud Event Space, we blend the warmth of Filipino hospitality with the serene beauty of Peliatan. Our culinary journey is a celebration of soul-stirring flavors, where traditional island influences meet modern refinement. Every menu we curate is a flexible masterpiece designed to mirror the organic elegance of our bamboo surroundings.
              </p>
              <p>
                Whether hosting an intimate dinner in Kilig Sala or a grand celebration in Bulwagan Hall, our food-forward approach ensures a sensory experience that lingers. From bespoke set menus to lavish buffet spreads, every dish is crafted with locally-sourced ingredients and a sophisticated, purposeful intent to delight your guests.
              </p>
            </div>

            <div className="mt-12">
              <Button asChild size="lg" variant="outline" className="rounded-md border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground tracking-widest uppercase text-xs font-bold px-8 h-14 transition-all duration-300 shadow-sm hover:shadow-md">
                <Link to="/PrivateDiningPage">Explore Our Menus</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full lg:w-5/12 mt-16 lg:mt-0 lg:-ml-16 relative z-10">
            <div className="relative w-full aspect-[4/5] shadow-xl shadow-primary/10 transition-transform duration-75 ease-linear rounded-lg overflow-hidden" style={{
            transform: `translateY(${offsetY > 0 ? offsetY % 100 - 50 : 0}px)`
          }}>
              {}
              <div className="absolute -inset-4 border border-secondary/20 pointer-events-none hidden md:block rounded-xl" />
              <div className="absolute -inset-2 border border-primary/5 pointer-events-none hidden md:block rounded-lg" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/luxury_culinary_table_setting.png" alt="Elegant Filipino-inspired dining setup at Ubud Event Space with warm bamboo accents" className="w-full h-full object-cover sepia-[10%] contrast-110 brightness-100" />
              
              {}
              <div className="absolute inset-0 shadow-[inset_0_0_80px_rgba(40,30,20,0.2)] pointer-events-none" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}